import { TrashIcon } from "@heroicons/react/outline";

import { CaseDocument } from "pwapi";

interface PendingDocumentListItemProps {
  category: CaseDocument.category;
  index: number;
  categories: CaseDocument.category[];
  setFieldValue: (field: string, value: unknown) => void;
  protectedIndices?: number[];
}

export const PendingDocumentListItem: React.FC<
  PendingDocumentListItemProps
> = ({ category, index, categories, protectedIndices, setFieldValue }) => {
  const isProtected = protectedIndices?.includes(index);

  const remove = () => {
    if (isProtected) return;

    const next = [...categories];
    next.splice(index, 1);
    setFieldValue("pending_documents", next);
  };

  return (
    <div className="Object Object--PendingDocument">
      <header>
        {category}

        <button
          type="button"
          className="Button--iconOnly"
          disabled={isProtected}
          title={
            isProtected
              ? "This document is required and cannot be removed."
              : "Remove pending document"
          }
          onClick={remove}
        >
          <TrashIcon />
        </button>
      </header>
    </div>
  );
};
